import React from "react";
import {useTranslation} from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";

export const TOOLTIP_PLACEMENT = Object.freeze({
  BOTTOM: "bottom",
  TOP: "top",
  BOTTOM_END: "bottom-end",
  BOTTOM_START: "bottom-start",
  LEFT_END: "left-end",
  LEFT_START: "left-start",
  LEFT: "left",
  RIGHT_END: "right-end",
  RIGTH_START: "right-start",
  RIGHT: "right",
  TOP_END: "top-end",
  TOP_START: "top-start",
});
export default function ToolTip({
  children,
  title,
  zIndex,
  bottom = false,
  className,
  noTranslation = false,
  placement,
  style,
  ...props
}) {
  const {t} = useTranslation();

  return title ? (
    <Tooltip
      {...props}
      title={typeof title === "string" && !noTranslation ? t(title) : title}
      arrow
      placement={placement ? placement : bottom ? "bottom" : "top"}
      PopperProps={{
        sx: {
          zIndex: zIndex ?? "100000",
          "& .MuiTooltip-tooltip": {
            backgroundColor: "white",
            color: "#426BA6",
            border: " 1px solid #426ca65e",
            fontSize: "0.9em",
            fontWeight: "300",
            zIndex: "100000",
          },
          "& .MuiTooltip-arrow": {
            color: "#426ca65e",
            zIndex: "100000",
          },
          "& .MuiTooltip-popper": {
            zIndex: "100000",
          },
        },
      }}
    >
      <div className={className} style={style}>
        {React.Children.only(children)}
      </div>
    </Tooltip>
  ) : (
    <div className={className} style={style}>
      {React.Children.only(children)}
    </div>
  );
}

ToolTip.propTypes = {
  children: PropTypes.node,
  // title: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object]),
  bottom: PropTypes.bool,
  className: PropTypes.string,
  props: PropTypes.array,
};
